import { create } from 'zustand';
import type { ReactNode } from 'react';

// PhotoOrganizerLayout의 우측 컨테이너 영역에 렌더링할 콘텐츠.
// 화면(라우트)별로 useRightSlot 훅을 통해 등록/해제한다.
interface RightSlotState {
  content: ReactNode;
  setContent: (content: ReactNode) => void;
}

export const useRightSlotStore = create<RightSlotState>((set) => ({
  content: null,
  setContent: (content) => set({ content }),
}));
